<template>
  <div class="main_box">
    <div v-if="!empty" class="big_box">
      <div class="center_infomation0">
        <div class="infomation_body_">
          <div class="status_">识别结果:</div>
          <div class="info_flex">
            <div style="margin-right: 10px" class="value_" v-for="(item, index) in DataHisInsectList" :key="item.id">{{ item.insectName }} {{ item.insectNum }}只</div>
          </div>
        </div>
      </div>
      <div class="center_infomation1">
        <div class="infomation_body_">
          <div class="status_">害虫排行:</div>
          <div class="info_flex">
            <div style="margin-right: 10px" class="value_" v-for="(item, index) in InsectRank" :key="item.id">
              <div class="yuan">{{ index + 1 }}</div>
              {{ item.insectName }} {{ item.insectNum }}只
            </div>
          </div>
        </div>
      </div>
      <div class="center_infomation2">
        <img class="chong_123" src="../../assets/img/chong.png" alt="" />
      </div>
      <div class="center">
        <el-carousel :interval="10000" type="card" height="120px" @change="getindex">
          <el-carousel-item v-for="(item, index) in picList" class="carousel" :key="index">
            <el-image :preview-src-list="pic" :src="item.value" :ref="'child' + index" style="height: 80%; width: auto" />
            <span class="title_" style="margin: auto; width: auto">
              {{ item.createDate_ }}
            </span>
          </el-carousel-item>
          <div class="empty-box3" v-if="empty">
            <img :src="empty_img" />
            <p>暂无数据</p>
          </div>
        </el-carousel>
      </div>
      <!-- <div class="selcet_bo">
        <el-select size="mini" class="selcet" @change="getAll(index)" v-model="chong_value" placeholder="请选择">
          <el-option v-for="(item, index) in deviceList" :key="item.id" :label="item.deviceName" :value="index"> </el-option>
        </el-select>
      </div> -->
      <div class="right_box">
        <div class="right_body">
          <div class="body" v-for="(item, index) in numericalDevices.numericalDevices" :key="index">
            <div class="bg_box">
              <div class="bg_box_img">
                <img class="bg_img" :src="item.attributeImage" alt="" />
              </div>
              <div>
                <div class="body_">
                  <div>
                    <div>
                      {{ item.attributeName }}
                    </div>
                    <div class="num">
                      {{ item.realData }}
                      <span class="unit">{{ item.attributeSymbol }}</span>
                    </div>
                  </div>
                  <!-- <div class="status">
                <span v-if="item.deviceStatus==0"> 在线</span>
                <span class="status1" v-if="item.deviceStatus==1">离线</span>
                <span class="status1" v-if="item.deviceStatus==2">告警</span>
              </div> -->
                </div>
                <div class="bottom_box">
                  <div class="time">{{ item.updateTime }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-if="empty">
      <el-empty description="暂无绑定虫情仪" :image-size="200"></el-empty>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    numericalDevices: {},
    index: {}
  },
  data() {
    return {
      chong_value: '',
      currentPage: 1, //初始页
      pagesize: 6, //    每页的数据
      total: 0, //总数
      picList: [],
      deviceList: [],
      informationList: [],
      showActive: 0,
      numericalDevices: [],
      environmentTemperature: {},
      ambientHumidity: {},
      longitude: [],
      rainGutter: {},
      signal: {},
      lightOperated: {},
      aisle: {},
      heatingMedium: [],
      binGate: [],
      address: '',
      empty: false,
      pic: [],
      InsectStationList: [],
      InsectId: '',
      InsectRank: [],
      imgIndex: 0,
      DataHisInsectList: []
    }
  },
  mounted() {
    console.log(this.numericalDevices, 879)
    this.getInfomation()
    this.getInsectStations()
  },
  methods: {
    getindex(val) {
      this.imgIndex = val
      this.getDataHisInsectList(this.picList[val].createDate)
    },
    getDataHisInsectList(val) {
      this.$api.device.getDataHisInsectList({ imageId: val, stationId: this.InsectId }).then(res => {
        if (res.code == 200) {
          this.DataHisInsectList = res.data
        }
      })
    },
    getAll(index) {
      this.showActive = index
      this.numericalDevices = this.deviceList[index].numericalDevices
      this.address = this.deviceList[index].address
      this.numericalDevices.map(item => {
        item.updateTime = this.getHMS(item.updateTime)
      })
      this.getInfomation()
      this.getPicImageList(this.deviceList[index].picDeviceId, this.deviceList[index].resultImageAttributeId)
      this.getInsectRank()
    },
    getInsectRank() {
      this.$api.device.getInsectRank(this.InsectId).then(res => {
        if (res.code == 200) {
          res.data = res.data.slice(0, 4)
          this.InsectRank = res.data
        }
      })
    },
    getInfomation() {
      this.numericalDevices.numericalDevices.map(item => {
        if (item.attributeName.includes('环境温度')) {
          this.environmentTemperature = item
        } else if (item.attributeName.includes('环境湿度')) {
          this.ambientHumidity = item
        } else if (item.attributeName.includes('经度')) {
          this.longitude.push(item)
        } else if (item.attributeName.includes('纬度')) {
          this.longitude.push(item)
        } else if (item.attributeName.includes('雨控')) {
          this.rainGutter = item
        } else if (item.attributeName.includes('信号')) {
          this.signal = item
        } else if (item.attributeName.includes('光控状态')) {
          this.lightOperated = item
        } else if (item.attributeName.includes('通道')) {
          this.aisle = item
        } else if (item.attributeName.includes('加热仓')) {
          this.heatingMedium.push(item)
        } else if (item.attributeName.includes('仓门')) {
          this.binGate.push(item)
        }
      })
    },
    getHomeMonitorList() {
      //获取分组列表
      this.$api.device.getHomeMonitorList({ type: 0 }).then(res => {
        if (res.code == 200) {
          if (res.data.length == 0) {
            this.empty = true
          } else {
            this.deviceList = res.data
            this.chong_value = 0
            this.numericalDevices = this.deviceList[0].numericalDevices
            this.address = this.deviceList[0].address
            this.numericalDevices.map(item => {
              item.updateTime = this.getHMS(item.updateTime)
            })
            this.getInfomation()
            this.getPicImageList(res.data[0].picDeviceId, res.data[0].resultImageAttributeId)
            this.getInsectRank()
          }
        }
      })
    },
    getInsectStations() {
      this.$api.device.getInsectStations().then(res => {
        if (res.code == 200) {
          this.InsectStationList = res.data
          this.InsectId = this.InsectStationList[this.index].id
          this.getInsectRank()
          this.getPicImageList(this.numericalDevices.picDeviceId, this.numericalDevices.imageAttributeId)
        }
      })
    },
    getHMS(timestamp) {
      var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '/'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    getPicImageList(id, imageAttributeId) {
      this.$api.device
        .getDataHisImageList(this.currentPage, this.pagesize, this.InsectId, imageAttributeId)
        .then(res => {
          if (res.code == 200) {
            this.picList = res.data

            this.picList.map(item => {
              item.createDate_ = this.getHMS(item.createDate)
              this.pic.push(item.value)
            })
            this.getDataHisInsectList(res.data[0].createDate)
            if (this.currentPage != 1 && res.data.length == 0) {
              this.currentPage = this.currentPage - 1
              //this.getDeviceList();
            } else {
              this.total = res.pageInfo.total
              if (res.data.length == 0) {
                this.empty = true
              } else {
                this.empty = false
              }
            }
          } else {
            this.empty = false
            this.$toaster.error(res.msg)
          }
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.swiper_title {
  font-size: 18px;
  margin-left: 2rem;
  font-weight: bold;
  color: #2494f2;
  margin-bottom: 10px;
}
::-webkit-scrollbar {
  width: 8px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cecdcd;
  border-radius: 4px;
}

.big_box {
  width: 70%;
  display: flex;
  justify-content: space-around;
  height: 500px;
}
.left_box {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 10px;
  width: 17%;
  background-color: #ffffff;
  height: 730px;
}
.left_head {
  width: 100%;
  height: 40px;
  line-height: 40px;

  background-color: #2494f2;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
.center_head {
  width: 100%;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  margin-left: 20px;
  color: #2494f2;
  font-weight: bold;
}
.title {
  font-size: 16px;
  margin-left: 20px;
  color: #ffffff;
  font-weight: bold;
}
.left_body {
  height: 660px;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
}
.body {
  cursor: pointer;
  height: 120px;
  display: flex;
  align-items: center;
  margin: 8px;
  border-radius: 20px;
  border: 1px solid #c5c6c7;
  justify-content: center;
}
.active {
  border: 2px solid #9ecbf3;
}
.text {
  margin-top: 1rem;
  font-size: 15px;
  color: #4aaafd;
  margin-left: 10px;
}
.yellow {
  color: #fcb046;
  margin-top: 15px;
  margin-bottom: 20px;
}
.black {
  color: #000;
  font-weight: normal;
}
.alertbox {
  display: flex;
  justify-content: center;
}
.bottom_box {
  width: 100%;
  margin-left: 30px;
  display: flex;
  justify-content: space-between;
}
.bottom_box .el-button.is-round {
  border-radius: 15px !important;
}
.bottom_box .el-button {
  padding: 0px !important;
  text-align: center !important;
  width: 60px !important;
  height: 25px !important;
  line-height: 0px !important;
}

.right_box {
  position: relative;
  right: 20%;
  top: 90px;
  margin-right: 20px;
  border-radius: 10px;
  width: 45%;
  background-color: #ffffff;
}

.right_head {
  width: 100%;
  height: 40px;
  line-height: 40px;

  background-color: #2494f2;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}

.right_body {
  width: 350px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow-y: scroll;
  height: 160px;
}
.right_body .body {
  width: 150px;
  height: 65px;
  display: flex;
  margin: 8px;
  border-radius: 10px;
  border: 2px solid #9ecbf3;
}

.center_box {
  margin-top: 20px;
  margin-right: 20px;
  border-radius: 10px;
  height: 730px;
  width: 60%;
}
.center_body {
  display: flex;
  height: 100%;
  position: relative;
}
.center_ {
  width: 100%;
}
.center {
  position: relative;
  width: 100%;
  height: 150px;
  bottom: -70%;
  left: 20%;
}
.center_infomation0 {
  z-index: 99999;
  top: 57%;
  left: 50%;
  position: absolute;
}
.center_infomation1 {
  z-index: 99999;
  top: 52%;
  left: 50%;
  position: absolute;
  /* border: 1.5px solid #60bef9; */
  border-radius: 10px;
  /* box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5); */
}
.center_infomation2 {
  top: 3rem;
  left: 35%;
  position: relative;
  z-index: 10;
}
.chong_123 {
  top: -30px;
  left: 0rem;
  position: absolute;
  width: 7rem;
}
.center_infomation3 {
  left: 48rem;
  top: 2rem;
  position: absolute;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation4 {
  left: 52rem;
  top: 12rem;
  position: absolute;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.center_infomation5 {
  left: 48rem;
  top: 22rem;
  position: absolute;
  border: 1.5px solid #60bef9;
  border-radius: 10px;
  box-shadow: 6px 6px 4px rgba(0, 0, 0, 0.5);
}
.infomation_head {
  width: 10rem;
  height: 30px;
  line-height: 30px;
  background-color: #2494f2;
  /* border-radius: 5px; */
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  color: #ffffff;
  font-size: 14px;
  padding-left: 10px;
  font-weight: bold;
}
.infomation_body {
  display: flex;
  align-items: center;
  flex-flow: column;
  align-items: space-around;
  width: 10rem;
  min-height: 50px;
  text-align: center;
  font-size: 15px;
}
.infomation_body_ {
  display: flex;
  /* align-items: center; */
  min-width: 18rem;
  height: 40px;
  padding-left: 10px;
  font-size: 14px;
  white-space: nowrap;
  align-items: center;
}
.info_body {
  margin-top: 5px;
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 30px;
  font-weight: bold;
}
.a131 {
  height: 20px;
  margin-top: 0px;
  margin-bottom: 3px;
}
.jrc_ {
  height: 70px;
}
.status_ {
  color: #000000;
  margin-right: 10px;
  margin-top: 5px;
}
.value_ {
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-top: 5px;
}

.center_img_chong_1 {
}
.center_img_chong {
  width: 6;
  margin-top: 3rem;
  margin-left: 17rem;
}
.center_img {
  width: 100%;
  height: 40%;
  margin-bottom: 1rem;
  background-color: #ffffff;
  border-radius: 20px;
}

.qi {
  width: 32rem;
  /* height: 50rem; */
  height: 100%;
}
.shui {
  width: 40rem;
  margin-left: 10rem;
  margin-top: 2rem;
}
.center_right {
  margin-left: -1rem;
  height: 100%;
}
.center_right_title {
  margin-left: 1.2rem;
}
.center_right_title_ {
  font-size: 17px;
  font-weight: bold;
}
.center_right_img {
  width: 4.8rem;
  margin-left: 1rem;
  margin-top: 0.5rem;
}

.null {
  font-weight: normal;
  font-size: 15px;
  color: #a19ebd;
  margin-top: 0.5rem;
}
.center_rightBoxs {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #09f87c; */
  border-bottom: 1px solid #a19ebd;
}
.center_rightBoxs_q {
  margin-top: 2rem;
  margin-left: 3rem;
  width: 16rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #09f87c; */
  border-bottom: 1px solid #a19ebd;
}
.right_body .bottom_box {
  margin-left: 5px;
  align-items: center;
}
.right_body .bottom_box .time {
  margin-left: 5px;
  font-size: 10px;
  font-weight: bold;
}
.right_body .bottom_box .el-button {
  width: 80px !important;
}
.num {
  font-size: 13px;
  color: #000;
  margin-top: 5px;
}
.unit {
  font-size: 12px;
}
.bg_box {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg_img {
  width: 2rem;
}
.body_ {
  margin-left: 10px;
  position: relative;
  width: 100%;
  height: 60%;
  display: flex;
  font-size: 13px;
}
.status {
  position: absolute;
  float: right;
  right: 15px;
  font-weight: bold;
  color: #09f87c;
}
.status1 {
  color: #aaaaaa;
}
.status1 {
  color: red;
}
.yuan {
  width: 0.9rem;
  height: 0.9rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border-radius: 50%;
  background-color: #ff5c00;
  margin-right: 10px;
}
.info_flex {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.title_ {
  font-size: 14px;
  color: #c5c6c7;
}
.selcet {
  width: 200px !important;
  z-index: 99999;
  float: right;
}
.selcet_bo {
  position: absolute;
  right: 15px;
}
.carousel {
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
}
.main_box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
}
.center_text {
  position: relative;
  width: 100%;
  height: 36px;
  font-size: 26px;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;
  color: #333;
  line-height: 36px;
  /* margin-left: 60px; */
}
</style>
